import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import { containerSizes, baseVariations, } from './constants';
import { BaseLoader, } from './Loader.base';
const Loader = ({ size, style, type, value = 0, }) => {
    const containerStyles = useMemo(() => (css `
        height: ${styleUtils.rem(containerSizes[size])};
        width: ${styleUtils.rem(containerSizes[size])};
      `), [
        size,
    ]);
    const localVariationStyles = useMemo(() => (baseVariations[style]), [
        style,
    ]);
    const localValue = useMemo(() => (type === 'determinate' && size === 'medium'
        ? value
        : undefined), [
        size,
        type,
        value,
    ]);
    return (_jsx(BaseLoader, { css: containerStyles, strokeBackgroundColor: localVariationStyles.strokeBackgroundColor, strokeColor: localVariationStyles.strokeColor, textColor: localVariationStyles.textColor, type: type, value: localValue }));
};
const MemoizedLoader = memo(Loader);
export { MemoizedLoader as Loader };
// MC-1068 Temporary hack for Storybook.
export default MemoizedLoader;
